import React, { useEffect, useState } from "react";
import "../App.css"; // ✅ Ensure the correct path
import "./css/Main.css"; // ✅ Ensure the correct path
import { RetellWebClient } from "retell-client-js-sdk";

const agentId = "agent_654c232310a10db5f7f5a78fa0";

interface RegisterCallResponse {
  access_token: string;
}

const retellWebClient = new RetellWebClient();

const Home = () => {
  const [isCalling, setIsCalling] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Track loading state

  useEffect(() => {
    retellWebClient.on("call_started", () => {
      console.log("call started");
    });

    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      setIsCalling(false);
      setIsLoading(false); // Reset loading state
    });

    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
    });

    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
    });

    retellWebClient.on("error", (error) => {
      console.error("An error occurred:", error);
      retellWebClient.stopCall();
      setIsCalling(false);
      setIsLoading(false); // Reset loading state on error
    });
  }, []);

  // Debounce function to prevent rapid clicks
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId); // Clear existing timeout
      }
      timeoutId = setTimeout(() => func(...args), delay); // Set new timeout
    };
  };

  // Toggle conversation with debounce
  const toggleConversationDebounced = debounce(async () => {
    if (isLoading) return; // Prevent multiple calls while loading

    setIsLoading(true); // Set loading state

    if (isCalling) {
      retellWebClient.stopCall();
      setIsCalling(false);
    } else {
      try {
        const registerCallResponse = await registerCall(agentId);
        if (registerCallResponse.access_token) {
          await retellWebClient.startCall({
            accessToken: registerCallResponse.access_token,
          });
          setIsCalling(true);
        }
      } catch (error) {
        console.error("Error starting call:", error);
      } finally {
        setIsLoading(false); // Reset loading state
      }
    }
  }, 300); // 5-second debounce delay

  // Register call with the agent
  async function registerCall(agentId: string): Promise<RegisterCallResponse> {
    try {
      const response = await fetch("https://demo.braincx.ai:8080/create-web-call", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ agent_id: agentId }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      console.error("Error registering call:", err);
      throw err;
    }
  }

  return (
    <div className="App">
      <header className="center">
        <div className="logo-div">
          <img className="logo-main" src="/images/logo-white.png" alt="BrainCX Logo" />
        </div>
        <div className="button-div"></div>
        <div className="icon-div">
          <div className="menu-icon">
            <i className="fa-solid fa-bars fa-lg"></i>
          </div>
        </div>
      </header>

      {/* 🔹 Fixed Content Layout */}
      <div className="content center">
        <h1 className="main-heading">Voice AI Experiences</h1>
        <p className="sub-heading">Emerging Technology Made Simple, Authentic, and Human</p>
        <p className="content-para">
          Let Voice AI answer your calls, schedule appointments, answer questions in any language, collect & organize
          information,<br />
          and integrate seamlessly with your systems – all through voice technology that feels genuine.
        </p>

        {/* 🔹 Fixed Buttons Layout */}
        <div className="buttons">
          <a
            className="btn-01"
            href="#"
            onClick={toggleConversationDebounced}
            style={{ pointerEvents: isLoading ? "none" : "auto", opacity: isLoading ? 0.7 : 1 }} // Disable button visually
          >
            {isCalling ? "Stop Demo" : "See Demo"}
          </a>
          <a className="btn-02" href="#">
            Contact BrainCX
          </a>
        </div>
      </div>

      {/* 🔹 Fixed Wave Video Section with Centered Button */}
      <div className="wave-section">
        <div className="main-button">
          <video className="video-back" autoPlay loop muted playsInline>
            <source src="/images/wave-ai.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <img
            className="main-audio-button"
            src="/images/button.png"
            alt="Audio Button"
            onClick={toggleConversationDebounced}
            style={{ pointerEvents: isLoading ? "none" : "auto", opacity: isLoading ? 0.7 : 1 }} // Disable button visually
          />
        </div>
      </div>
    </div>
  );
};

export default Home;